import { render, staticRenderFns } from "./dnssec.vue?vue&type=template&id=7b863a2e&scoped=true"
import script from "./dnssec.vue?vue&type=script&lang=js"
export * from "./dnssec.vue?vue&type=script&lang=js"
import style0 from "./dnssec.vue?vue&type=style&index=0&id=7b863a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b863a2e",
  null
  
)

export default component.exports